import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import footerScripts from './FooterScripts';
import useCommonScripts from './CommonScripts';
import ScrollTop from './ScrollTop';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  useEffect(() => {
    footerScripts();
  }, []);
  useCommonScripts();
  return (
    <>
      <footer className="footer-wrapper footer-layout1 space-top">
        <div className="footer-shape1" data-bg-src="assets/img/shape/footer-bg-shape1-1.png">
          <img src="assets/img/shape/footer-bg-shape1-1.png" alt="img" />
        </div>
        <div className="footer-shape2 spin d-md-block d-none">
          <img src="assets/img/shape/footer-bg-shape1-2.png" alt="img" />
        </div>
        <div className="footer-shape3 spin">
          <img src="assets/img/shape/footer-bg-shape1-3.png" alt="img" />
        </div>
        <div className="container">
          <div className="footer-top" data-cue="slideInUp">
              <div className="cta-content" data-bg-src="assets/img/bg/cta_bg_shape1.png">
              <h2 className="mb-0">{t('FooterOne.cta_title_one','Discover How We Can')} <span className="text-theme">{t('FooterOne.cta_title_two','Support')}</span> {t('FooterOne.cta_title_three','Your Secure Advancement.')}</h2>
              <Link to="/contact" className="ot-btn">{t('FooterOne.cta_btn_text','Register Now')}<i className="far fa-long-arrow-right ms-2"></i></Link>
            </div>
          </div>
        </div>
        <div className="widget-area">
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-md-6 col-xl-auto" data-cue="slideInUp">
                <div className="widget footer-widget">
                      <div className="ot-widget-about">
                    <div className="about-logo">
                      <Link to="/">
                        <img src="assets/img/logo.svg" alt="Secur" />
                      </Link>
                    </div>
                    <p className="about-text">{t('FooterOne.about_text','Since 1999, Secur has been a trusted leader in cybersecurity, protecting digital assets with.')}</p>
                    <div className="ot-social">
                      <a href="https://www.facebook.com/" rel="noopener noreferrer" target="_blank"><i className="fab fa-facebook-f"></i></a>
                      <a href="https://www.twitter.com/" rel="noopener noreferrer" target="_blank"><i className="fab fa-twitter"></i></a>
                      <a href="https://www.linkedin.com/" rel="noopener noreferrer" target="_blank"><i className="fab fa-linkedin-in"></i></a>
                      <a href="https://www.youtube.com/" rel="noopener noreferrer" target="_blank"><i className="fab fa-youtube"></i></a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto" data-cue="slideInUp">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">{t('FooterOne.widget_title_it_solution','IT Solution')}</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li><Link to="/service">{t('FooterOne.widget_one_link_1','Malware Protection')} </Link></li>
                      <li><Link to="/service">{t('FooterOne.widget_one_link_2','Computer Security')}</Link></li>
                      <li><Link to="/service">{t('FooterOne.widget_one_link_3','Server Protection')} </Link></li>
                      <li><Link to="/service">{t('FooterOne.widget_one_link_4','Cyber Security')}</Link></li>
                      <li><Link to="/service">{t('FooterOne.widget_one_link_5','Security Monitoring')}</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto" data-cue="slideInUp">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">{t('FooterOne.widget_title_quick_link','Quick Link')}</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      <li><Link to="/about">{t('FooterOne.quick_link_about','About Secur')}</Link></li>
                      <li><Link to="/service">{t('FooterOne.quick_link_our_services','Our Services')}</Link></li>
                      <li><Link to="/pricing">{t('FooterOne.quick_link_pricing_plan','Pricing Plan')}</Link></li>
                      <li><Link to="/portfolio">{t('FooterOne.quick_link_our_portfolio','Our Portfolio')}</Link></li>
                      <li><Link to="/team">{t('FooterOne.quick_link_our_team','Our Team')}</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto" data-cue="slideInUp">
                <div className="widget footer-widget">
                  <h3 className="widget_title">{t('FooterOne.widget_title_contact_us','Contact Us')}</h3>
                  <div className="ot-widget-contact">
                    <div className="info-box">
                      <div className="box-icon">
                        <i className="far fa-map-marker-alt"></i>
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">{t('FooterOne.location','Location')}</h3>
                        <p className="box-text">{t('FooterOne.location_address','932 Dogwood Road,Chapel Hill,North Carolina')}</p>
                      </div>
                    </div>
                    <div className="info-box">
                      <div className="box-icon">
                        <i className="far fa-phone"></i>
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">{t('FooterOne.phone','Phone')}</h3>
                        <a className="box-link" href="tel:16555778749">+165-5577-8749,</a>
                        <a className="box-link" href="tel:16535647488">+165-3564-7488</a>
                      </div>
                    </div>
                    <div className="info-box">
                      <div className="box-icon">
                        <i className="far fa-clock"></i>
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">{t('FooterOne.opening_hour','Opening Hour')}</h3>
                        <p className="box-text">{t('FooterOne.opening_hour_bottom_text','Mon - Sat: 10.00 AM - 4.00 PM')} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container text-center">
            <div className="row gy-3 justify-content-between align-items-center">
              <div className="col-md-auto" data-cue="slideInLeft">
                <p className="copyright-text"><i className="fal fa-copyright"></i> {t('FooterOne.copyright_text','Copyright 2026 Secur All Rights Reserved.')}</p>
              </div>
              <div className="col-md-auto">
                <div className="footer-links" data-cue="slideInRight">
                  <ul>
                    <li><Link to="/about">{t('FooterOne.terms_and_condition','Terms & Condition')}</Link></li>
                    <li><Link to="/about">{t('FooterOne.privacy_policy','Privacy Policy')}</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <ScrollTop />
      
    </>
  );
};

export default Footer;